import React from "react";
import { Button, Modal } from "react-bootstrap";
import { ALLOWED_MULTI_ROUTE_CITIES, MessageType } from "../../../../../Constant";
import validateVehicle from "../../validator/vehicleValidators";
import { createOrUpdateVehicle,generateTimestamp } from "../../../../../services/vehicleService";
import { VehicleState } from "../../models/vehicleModels";
import CityToAgencyMapping from "./cityToAgencyMapping";
import Config from "../../../../../config";
import Select from "react-select";
import { DatePickerComponent } from "../../../../../shared/widgets";
import * as moment from "moment";
import { fetchProtocolType, fetchVehicleMetaData,fetchBusClassification,fetchTags,fetchServiceProviderWithCity,fetchFuelTypes, fetchLayoutNames, fetchOwnerList } from "../../../../../services/vehicleMasterService";
import { fetchRegions,fetchRoutesData,fetchDispatchTypesData } from "../../../../../services/regionService";
import { mappedRoutesData,generateRouteIdOptions, generateLabelForRoute } from './util';
import PropTypes from "prop-types";
import MultiSelectInput from "../../../../../shared/widgets/chaloSequenceMultiSelectDropDown";
import VehicleSeatingLayout from "../../../../../shared/components/vehicleSeatingLayout/vehicleSeatingLayout";
export default class VehicleCreate extends React.Component {
    constructor(props) {
        super(props);

        const updateSelection = props.updateSelection;
        const now = moment(new Date());
        const defaults = this.getDefaultServiceWindow();

        const toOption = (value) =>
            value ? { label: value, value } : '';

        const yesNoFromOriginal = (value) =>
            value
                ? { label: 'Yes', value: 'Yes' }
                : { label: 'No', value: 'No' };

        this.state = {
            vehicleCode: updateSelection?.vehicleCode ?? '',
            vehicleNo: updateSelection?.vehicleNo ?? '',
            deviceId: updateSelection?.deviceId ?? '',
            simCard: updateSelection?.simCard ?? '',
            secondarySim: updateSelection?.secondarySim ?? '',
            afcsAccountId: updateSelection?.afcsAccountId ?? '',

            make: updateSelection?.make ?? '',
            model: updateSelection?.model ?? '',
            version: updateSelection?.version ?? '',
            owner: updateSelection?.owner ?? '',
            ownerMaster: '',
            ownerMasterOptions: [],
            chasisNumber: updateSelection?.chasisNumber ?? '',
            engineNumber: updateSelection?.engineNumber ?? '',
            seatingCapacity: updateSelection?.seatingCapacity ?? '',
            standingCapacity: updateSelection?.standingCapacity ?? '',
            fuelType: toOption(updateSelection?.fuelType),
            serviceCategory: updateSelection?.serviceCategory ?? '',
            serviceProvider: updateSelection?.serviceProvider ?? '',
            dispatchType: updateSelection?.dispatchType ?? '',
            overspeedLimit:
                updateSelection?.vehicleDispatchConfigDto?.overspeedLimit ?? '',
            fuelCapacity: updateSelection?.fuelCapacity ?? 0,
            stayOpen: false,
            removeSelected: true,
            rtl: false,
            disabled: false,
            cameraIdError: false,
            showMultiRouteSelect: false,
            showDisabledSeatsModal: false,

            vehicleType: toOption(updateSelection?.vehicleType),
            serviceType: toOption(updateSelection?.serviceType),
            operationType: toOption(updateSelection?.operationType),
            gstOnTicket: toOption(updateSelection?.gstOnTicket),
            surchargeOnTicket: toOption(updateSelection?.surchargeOnTicket),
            collectionOnEtim: toOption(updateSelection?.collectionOnEtim),
            protocolType: toOption(updateSelection?.protocolType),
            tag: updateSelection?.tag?.tag
                ? toOption(updateSelection.tag.tag)
                : '',

            fuelPlan: yesNoFromOriginal(updateSelection?.fuelPlan),
            gpsRequiredFromEtim: yesNoFromOriginal(
                updateSelection?.gpsRequiredFromEtim
            ),

            selectedDate: updateSelection?.registrationDate ?? '',
            registrationDate: updateSelection?.registrationDate
                ? moment(new Date(updateSelection.registrationDate))
                : now,

            serviceStartTime: updateSelection
                ? ''
                : defaults.serviceStartTime,
            serviceEndTime: updateSelection
                ? ''
                : defaults.serviceEndTime,

            etimFrequency: updateSelection?.etimFrequency ?? 30,

            vehicleSeatingLayoutDto:
                updateSelection?.vehicleSeatingLayoutDto
                    ? {
                        label: `${updateSelection.vehicleSeatingLayoutDto.name}[${updateSelection.vehicleSeatingLayoutDto.layoutId}]`,
                        value: updateSelection.vehicleSeatingLayoutDto.layoutId,
                        layout: updateSelection.vehicleSeatingLayoutDto.layout,
                        name: updateSelection.vehicleSeatingLayoutDto.name,
                        seatingCapacity: updateSelection.vehicleSeatingLayoutDto.seatingCapacity,
                    }
                    : '',
            disabledSeats: updateSelection?.disabledSeats ?? [],
            form: {},
            regions: [],
            serviceTypeMeta: [],
            operationTypeMeta: [],
            vehicleTypeMeta: [],
            applicationMeta: [],
            applications: [],
            protocolTypeList: [],
            busClassificationOptions: [],
            serviceProviderOptions: [],
            dispatchTypeOptions: [],
            routeIdOptions: [],
            tagOptions: [],

            cameras: updateSelection?.cameras
                ? this.FilterCameras(updateSelection.cameras)
                : '',
            city: '',
            depotName: '',
            agencyName: '',
            operator: '',
            selectedRegion: {
                label: this.capitalize(props.selectedRegion),
                value: props.selectedRegion,
            },

            propertyApplicableOptions: [
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
            ],
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.onCityMappingChange = this.onCityMappingChange.bind(this);
        this.dateChange = this.dateChange.bind(this);
        this.fetchBusClassification = this.fetchBusClassification.bind(this);
        this.fetchServiceProviderOptions =
            this.fetchServiceProviderOptions.bind(this);
        this.fetchTags = this.fetchTags.bind(this);
        this.fetchRoutes = this.fetchRoutes.bind(this);
    }



    componentDidMount() {
        this.mounted = true;
        this.fetchRegions();
        this.fetchProtocolTypeList();
        this.fetchVehicleData('vehicleType', 'vehicleTypeMeta')
        this.fetchVehicleData('serviceType', 'serviceTypeMeta')
        this.fetchVehicleData('operationType', 'operationTypeMeta')
        this.fetchVehicleData('applications', 'applicationMeta');
        this.fetchTags(null);
        this.getFuelOptions();
        this.fetchDispatchTypes();
        this.getLayoutOptions();
        if(this.props.updateSelection){
        this.fetchRoutes();
        }
        this.fillVehicleDispatchConfigDto();
        this.checkAllowedCityForMultiRoute();
    }

    checkAllowedCityForMultiRoute = () => {
        const normalize = (val) => val?.toString().trim().toLowerCase() || '';
        const regionVal = normalize(this.state.selectedRegion?.value);

        const showMultiRouteSelect = 
            regionVal && ALLOWED_MULTI_ROUTE_CITIES.includes(regionVal);

        this.setState({ showMultiRouteSelect : showMultiRouteSelect });
    };



    fetchBusClassification(cityData){
        this.setState(
          { busClassificationOptions: [], serviceCategory: "" },
          () => {
            this.updateFormErrorState();
          }
        );
        fetchBusClassification(cityData).then((res) => {
            if(res && res.length){
                const data = res.reduce((acc,curr)=>{
                    acc.push({label:curr.serviceName,value:curr.serviceName,id:curr.serviceId})
                    return acc;
                },[]);
                this.setState({busClassificationOptions:data});
                if(this.props.updateSelection && this.props.updateSelection.serviceCategory){
                    const serverServiceCategory = data.find((i)=>i.value == this.props.updateSelection.serviceCategory);
                    if(serverServiceCategory){
                        this.setState(
                          { serviceCategory: serverServiceCategory },
                          () => {
                            this.updateFormErrorState();
                          }
                        );
                    }
                }
            }
        }).catch(function (err) {
            console.log(err);
        });
    }

    fetchOwnerOptions(operatorId = '', cityId = '',status = true) {
        this.setState({ ownerOptions: [], ownerMaster: '' }, () => this.updateFormErrorState());

        fetchOwnerList(operatorId,cityId,status)
            .then((res) => {
                if (res?.length) {
                    const ownerOptions = res.map((o) => ({
                        label: o.name,
                        value: o.ownerCode,
                        id: o.id,
                    }));
                    this.setState({ ownerOptions }, () => {
                        // re-select if editing
                        const existing = this.props.updateSelection?.ownerMaster;
                        if (existing) {
                            const match = ownerOptions.find((o) => o.value === existing?.ownerCode);
                            if (match) this.setState({ ownerMaster: match }, () => this.updateFormErrorState());
                        }
                    });
                }
            })
            .catch((err) => console.log('fetchOwnerOptions error', err));
}

    fetchServiceProviderOptions(cityData){
        this.setState({
            serviceProviderOptions:[],serviceProvider:""
        },()=>{
            this.updateFormErrorState();
        });
        fetchServiceProviderWithCity(cityData)
        .then((res) => {
            if(res?.length){
                const data = res.reduce((acc,curr)=>{
                    acc.push({label:curr.serviceProviderName,value:curr.serviceProviderName,id:curr.serviceProviderId})
                    return acc;
                },[]);
                this.setState({serviceProviderOptions:data});
                if(this.props.updateSelection?.serviceProvider){
                    const serverServiceProviderName= data.find((i)=>i.value == this.props.updateSelection.serviceProvider);
                    if(serverServiceProviderName){
                        this.setState(
                          { serviceProvider: serverServiceProviderName },
                          () => {
                            this.updateFormErrorState();
                          }
                        );
                    }
                }
            }
        }).catch(function (err) {
            console.log(err);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.updateSelection !== prevProps.updateSelection) {
            const newDate = this.props.updateSelection?.registrationDate;
            if (newDate && newDate !== this.state.selectedDate) {
                this.setState({
                    registrationDate: moment(new Date(newDate)),
                    selectedDate: newDate
                });
                console.log(" in componentDidUpdate if");
                this.updateFormData(this.props.updateSelection);
            } else {
                console.log(" in componentDidUpdate else");
                this.updateFormData(this.props.updateSelection);
                this.updateFormErrorState();
            }
        }

        if (prevState && prevState.showDisabledSeatsModal !== this.state.showDisabledSeatsModal) {
            const firstModal = document.querySelector('.custom-vehicle-modal')?.parentElement;
            if (firstModal) {
                if (this.state.showDisabledSeatsModal) {
                    firstModal.style.opacity = '0';
                    firstModal.style.pointerEvents = 'none';
                } else {
                    firstModal.style.opacity = '1';
                    firstModal.style.pointerEvents = 'auto';
                }
            }
        }
    }


    updateFormData(vehicle) {
        if(vehicle){
            if(this.state.vehicleNo && !vehicle.vehicleNo){
                vehicle.vehicleNo = this.state.vehicleNo;
            }
            this.setState(new VehicleState(vehicle), () => {
                this.updateFormErrorState();

            });
        }

    }

    FilterCameras(val){
        var cameraIds = val.map(function(item) {
            return item['cameraId'];
        });
        return cameraIds.toString();
    }

    onCityMappingChange(data) {
        const isCityOrAgencyDifferent = (current, incoming) => {
            if (!incoming) return false;
            if (!current) return true;
            return JSON.stringify(current) !== JSON.stringify(incoming);
        };

        const checkIsCityOrAgencyChange = () => {
            return !!data.agencyName && (
            isCityOrAgencyDifferent(this.state.agencyName, data.agencyName) ||
            (data.city && isCityOrAgencyDifferent(this.state.city, data.city))
            );
        };

        if (checkIsCityOrAgencyChange()) {
            const payload = {
            agencyName: data.agencyName.value.name,
            cityId: data.city.value.id,
            };
            this.fetchBusClassification(payload);
            this.fetchServiceProviderOptions(payload);
        }
        const operatorId = data.operator?.value?.id  || '';
        if (operatorId) {
            this.fetchOwnerOptions(operatorId);
        }

        const isCityOrAgencyChanged =
            isCityOrAgencyDifferent(this.state.city, data.city) ||
            isCityOrAgencyDifferent(this.state.agencyName, data.agencyName);

        if (isCityOrAgencyChanged) {
            this.setState({ routeId: null, routeIdOptions: [] }, () => {
            this.updateFormErrorState();
            });
        }

        this.setState(data, () => {
            this.updateFormErrorState();
            if (
            this.state.city &&
            this.state.agencyName &&
            this.state.routeIdOptions.length === 0
            ) {
            this.fetchRoutes();
            }
        });
    }



    preventSpecialCharacter(event, value) {
        const re = /^[a-zA-Z0-9]+$/
        if (!re.test(value)) {
            event.preventDefault();
        }
    }

    preventAlphaCharacter(event, key) {
        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Tab',
            'Home',
            'End'
        ];

        const isDigit = /^\d$/.test(key);


        if (!isDigit && !allowedKeys.includes(key)) {
            event.preventDefault();
        }
    }


    dateChange(date) {
        const momentDate = moment(date);
        this.setState({
            selectedDate: momentDate.startOf('day').format('x'),
            registrationDate: date
        });
    }

    fetchVehicleData(masterType, options) {
        fetchVehicleMetaData(masterType).then((res => {
            if (this.mounted) {
                const mappedMeta = res.map((data) => {
                    if (data.id) {
                        return { label: data.name, value: data }
                    } else {
                        return { label: data, value: data }
                    }
                });

                this.setState({
                    [options]: mappedMeta
                });

                if (this.props.updateSelection && masterType === 'applications') {
                    let applications = this.props.updateSelection.applications;

                    if (applications.length > 0) {
                        const filtered = mappedMeta.filter(app =>
                            applications.some(b => app.label === b.name)
                        );

                        this.setState({
                            applications: filtered
                        }, () => {
                            this.updateFormErrorState();
                        });
                    }
                }
            }
        })).catch(err => {
            this.props.onComplete(MessageType.ERROR, (err.description ? err.description : "Error occurred "));
        });
    }


    
    fetchRegions() {
        fetchRegions().then((res) => {
            if (res && res.items) {
                const orderedNewOptions = res.items.sort((a,b)=>{
                    return a.regionId > b.regionId ? 1 : b.regionId > a.regionId ? -1 : 0;
                });

                this.setState({
                    regions: orderedNewOptions.map((data) => {
                        return { label: this.capitalize(data.regionId), value: data.regionId }
                    })
                }, () => this.updateFormErrorState())
            }

        }).catch(function (err) {
            console.log(err);
        });
    }

    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
      }

    fetchTags(region) {
        this.setState({ tagOptions: [] }, () => this.updateFormErrorState());

        fetchTags(region || this.state.selectedRegion)
            .then((res) => {
                if (res) {
                    const tagOptions = res.map((el) => ({
                        ...el,
                        label: el.tag,
                        value: el.tag,
                    }));

                    this.setState((prevState) => {
                        let selectedTag = '';
                        if (prevState.tag) {
                            const match = tagOptions.find(
                                (opt) =>
                                    opt.value === prevState.tag?.value ||
                                    opt.value === prevState.tag
                            );
                            if (match) {
                                selectedTag = match;
                            }
                        }

                        return {
                            tagOptions,
                            tag: selectedTag || prevState.tag,
                        };
                    }, () => this.updateFormErrorState());
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ tagOptions: [], tag: '' });
            });
    }



    getFuelOptions = ()=>{
        fetchFuelTypes().then((res)=>{
         this.setState({
             fuelOptions: res.map((data) => {
                 return { label: data, value: data }
             })
         })
        })
    }
    getLayoutOptions = () =>{
        fetchLayoutNames().then((res)=>{
            this.setState({
                layoutOptions: res.map((data) => {
                    return { label: `${data.name}[${data.layoutId}]`, value: data.layoutId, layout: data.layout, name: data.name, seatingCapacity: data.seatingCapacity }
                })
            })
        })
    }
    
    render() {
        const disabledSeatsString = this.props.updateSelection?.disabledSeats?.join(', ') || "";
        return (
                <form className="row">
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Region Id</span></label>
                                <div>
                                    {/* <span>{this.props.selectedRegion}</span> */}
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            onChange={(value) => {
                                                this.handleSelectChange('selectedRegion', value)

                                            }}
                                            options={this.state.regions}
                                            placeholder="Select Region"
                                            isClearable={false}
                                            rtl={this.state.rtl}
                                            value={this.state.selectedRegion}
                                        />
                                        :
                                        this.props.updateSelection.selectedRegion}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Vehicle No</span></label>
                                <div>
                                    {(this.props.showInfo || this.props.updateSelection) ?
                                        <span>{this.props.updateSelection.vehicleNo}</span> :
                                        <span>
                                            <input type="text" autoComplete="off" className="form-control" id="vehicleNo"
                                                placeholder="Enter Vehicle No"
                                                onChange={(value) => {
                                                    this.setState({ vehicleNo: value.target.value.trim() }, () => {
                                                        this.updateFormErrorState()
                                                    })
                                                }}
                                                onKeyDown={(value) => {
                                                    this.preventSpecialCharacter(value, value.key);
                                                }}
                                                onPaste={(value) => {
                                                    this.preventSpecialCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                                }}
                                                defaultValue={this.props.updateSelection ? this.props.updateSelection.vehicleNo : ""}
                                            />
                                            <span className="info-text">Only Alphabets and Numbers are allowed</span>
                                        </span>}

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Vehicle Code</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <input type="text" className="form-control" id="vehicleCode"
                                            placeholder="Enter Vehicle code"
                                            onChange={(value) => {
                                                this.setState({ vehicleCode: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.vehicleCode : ""} />
                                        :
                                        <span>{this.props.updateSelection.vehicleCode}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Device Id</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <input type="text" className="form-control" id="deviceId"
                                            placeholder="Enter Device Id"
                                            onChange={(value) => {
                                                this.setState({ deviceId: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.deviceId : ""} />
                                        :
                                        <span>{this.props.updateSelection.deviceId}</span>}
                                </div>
                            </div>
                        </div>
                    {Config.operatorBasedVehicle &&
                        <CityToAgencyMapping showInfo={this.props.showInfo} updateSelection={this.props.updateSelection}
                            onDataChange={this.onCityMappingChange} />}



                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Make</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.make}</span> :
                                        <input type="text" className="form-control" id="make"
                                            placeholder="Enter Value..."
                                            onChange={(value) => {
                                                this.setState({ make: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.make : ""} />

                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Owner</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.owner}</span> :
                                        <input type="text" className="form-control" id="owner"
                                            placeholder="Enter Owner"
                                            onChange={(value) => {
                                                this.setState({ owner: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.owner : ""} />

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7" className="form-label">Owner Master</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.setState({ ownerMaster: value }, () => this.updateFormErrorState());
                                            }}
                                            isClearable={true}
                                            options={this.state.ownerOptions}
                                            placeholder="Select Owner"
                                            rtl={this.state.rtl}
                                            value={this.state.ownerMaster}
                                        />
                                        :
                                        this.props.updateSelection.ownerMaster
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Model</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.model}</span> :
                                        <input type="text" className="form-control" id="model"
                                            placeholder="Enter Model"
                                            onChange={(value) => {
                                                this.setState({ model: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.model : ""} />

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Version</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.version}</span> :
                                        <input type="text" className="form-control" id="version"
                                            placeholder="Enter version"
                                            onChange={(value) => {
                                                this.setState({ version: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.version : ""} />

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Vehicle Type</span></label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('vehicleType', value)
                                            }}
                                            options={this.state.vehicleTypeMeta}
                                            placeholder="Select Vehicle Type"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            value={this.state.vehicleType}
                                        />
                                        :
                                        this.props.updateSelection.vehicleType}
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Registration Date</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <div className="custom-date-input">
                                            <DatePickerComponent date={this.state.registrationDate} onDateChange={this.dateChange} withoutDefaultBorder={true} />
                                        </div>
                                        :
                                        this.props.updateSelection.registrationDate}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="form-group">
                                <label htmlFor="name7"
                                    className="form-label">Service Type</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('serviceType', value)
                                            }}
                                            options={this.state.serviceTypeMeta}
                                            placeholder="Select Service Type"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            value={this.state.serviceType}
                                            isClearable={true}
                                        />
                                        :
                                        this.props.updateSelection.serviceType}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Operation Type</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('operationType', value)
                                            }}
                                            options={this.state.operationTypeMeta}
                                            placeholder="Select Operation Type"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            value={this.state.operationType}
                                            isClearable={true}
                                        />
                                        :
                                        this.props.updateSelection.operationType}
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Seating Capacity</span></label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.seatingCapacity}</span> :
                                        <input type="number" min="0" className="form-control" id="seatingCapacity"
                                            placeholder="Enter Seating Capacity"
                                            onChange={(value) => {
                                                this.setState({ seatingCapacity: value.target.value.trim() }, () => {
                                                    this.updateFormErrorState()
                                                })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            value={this.state.seatingCapacity}
                                        />}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Standing Capacity</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.standingCapacity}</span> :
                                        <input type="number" min="0" className="form-control" id="standingCapacity"
                                            placeholder="Enter Standing Capacity"
                                            onChange={(value) => {
                                                this.setState({ standingCapacity: value.target.value.trim() })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.standingCapacity : ""}
                                        />}
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Layout Type</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            onChange={(value) => {
                                                this.setState({
                                                    vehicleSeatingLayoutDto:value,
                                                    seatingCapacity: value ? value.seatingCapacity : "",
                                                    disabledSeats: []
                                                },()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={true}
                                            options={this.state.layoutOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.vehicleSeatingLayoutDto}
                                        />
                                         :
                                        this.props.updateSelection.vehicleSeatingLayoutDto} 
                                </div>
                            </div>
                    </div>

                    <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Disabled Seats</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <div className="d-flex">
                                            <input type="text" className="form-control"
                                            id="disabledSeats" placeholder="Select seats"
                                            disabled
                                            value={this.state.disabledSeats.join(', ')}                                         
                                            />
                                            <div className="d-flex ms-2">
                                                <button type="button" className="form-action-button" onClick={() => this.setState({showDisabledSeatsModal: true})}><i className="fa fa-pencil-square-o" aria-hidden="true"/></button>
                                            </div>
                                        </div>
                                         :
                                         disabledSeatsString} 
                                </div>
                            </div>
                    </div>

                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">SIM 1</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.simCard}</span> :
                                        <input type="text" className="form-control" id="simNo"
                                            placeholder="Enter SIM number"
                                            onChange={(value) => {
                                                this.setState({ simCard: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.simCard : ""} />

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">SIM 2</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.secondarySim}</span> :
                                        <input type="text" className="form-control" id="simNo2"
                                            placeholder="Enter SIM number"
                                            onChange={(value) => {
                                                this.setState({ secondarySim: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.secondarySim : ""} />

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Application</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            isMulti
                                            onChange={(value) => {
                                                this.handleSelectChange('applications', value)
                                            }}
                                            options={this.state.applicationMeta}
                                            placeholder="Select Applications"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            value={this.state.applications}
                                        />
                                        :
                                        this.props.updateSelection.applications}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>GST on Ticket</span></label>
                                <div>


                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('gstOnTicket', value)
                                            }}
                                            options={this.state.propertyApplicableOptions}
                                            placeholder="Select"
                                            isClearable={false}
                                            rtl={this.state.rtl}
                                            value={this.state.gstOnTicket}
                                        />
                                        :
                                        this.props.updateSelection.gstOnTicket}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Surcharge On Ticket </span></label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('surchargeOnTicket', value)
                                            }}
                                            isClearable={false}
                                            options={this.state.propertyApplicableOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.surchargeOnTicket}
                                        />
                                        :
                                        this.props.updateSelection.surchargeOnTicket}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label"><span>Collection On Etim</span></label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('collectionOnEtim', value)
                                            }}
                                            options={this.state.propertyApplicableOptions}
                                            placeholder="Select"
                                            isClearable={false}
                                            rtl={this.state.rtl}
                                            value={this.state.collectionOnEtim}
                                        />
                                        :
                                        this.props.updateSelection.collectionOnEtim}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Afcs Account Id</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <input type="text" className="form-control" id="afcsAccountId"
                                            placeholder="Enter Acount Id"
                                            onChange={(value) => {
                                                this.setState({ afcsAccountId: value.target.value.trim() })
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.afcsAccountId : ""} />
                                        :
                                        <span>{this.props.updateSelection.afcsAccountId}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Fuel Plan </label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('fuelPlan', value)
                                            }}
                                            isClearable={true}
                                            options={this.state.propertyApplicableOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.fuelPlan}
                                        />
                                        :
                                        this.props.updateSelection.fuelPlan}
                                </div>
                            </div>
                        </div>
                    <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">GPS From Etim </label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('gpsRequiredFromEtim', value)
                                            }}
                                            isClearable={true}
                                            options={this.state.propertyApplicableOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.gpsRequiredFromEtim}
                                        />
                                        :
                                        this.props.updateSelection.gpsRequiredFromEtim}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Etim Frequency</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.etimFrequency}</span> :
                                        <input type="number" min="1" className="form-control" id="etimFrequency"
                                            placeholder="Enter Frequency"
                                            onChange={(value) => {
                                                this.setState({ etimFrequency: value.target.value.trim() })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.etimFrequency : 30}
                                        />}
                                </div>(seconds)
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Protocol Type </label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.handleSelectChange('protocolType', value)
                                            }}
                                            isClearable={true}
                                            options={this.state.protocolTypeList}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.protocolType}
                                        />
                                        :
                                        this.props.updateSelection.protocolType}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Engine Number</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.engineNumber}</span> :
                                        <span>
                                            <input type="text" className="form-control" id="engineNumber" autoComplete="off"
                                            placeholder="Enter Engine number"
                                            onChange={(value) => {
                                                this.setState({ engineNumber: value.target.value.trim() })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventSpecialCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventSpecialCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            disabled={!(this.state.protocolType && this.state.protocolType.label==='AIS')}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.engineNumber : ""} />
                                            <span className="info-text">Only Alphabets and Numbers are allowed</span>
                                        </span>

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="name7"
                                    className="form-label">Chasis Number</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.chasisNumber}</span> :
                                        <span>
                                            <input type="text" className="form-control" id="chasisNumber" autoComplete="off"
                                            placeholder="Enter Chasis number"
                                            onChange={(value) => {
                                                this.setState({ chasisNumber: value.target.value.trim() })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventSpecialCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventSpecialCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            disabled={!(this.state.protocolType && this.state.protocolType.label==='AIS')}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection.chasisNumber : ""} />
                                            <span className="info-text">Only Alphabets and Numbers are allowed</span>
                                        </span>

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label"><span>Service Category</span> </label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                
                                                this.setState({serviceCategory:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={false}
                                            options={this.state.busClassificationOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.serviceCategory}
                                        />
                                         :
                                        this.props.updateSelection.serviceCategory} 
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label"><span>Overspeed Limit</span></label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.vehicleDispatchConfigDto.overspeedLimit}</span> :
                                        <input type="number" min="1" className="form-control" id="overspeedLimit"
                                            placeholder="Enter Overspeed Limit"
                                            onChange={(value) => {
                                                this.setState({ overspeedLimit: value.target.value.trim() }, () => {
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection?.vehicleDispatchConfigDto?.overspeedLimit : ''}
                                        />}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Fuel Capacity</label>
                                <div>
                                    {this.props.showInfo ?
                                        <span>{this.props.updateSelection.vehicleDispatchConfigDto.fuelCapacity}</span> :
                                        <input type="number" min="0" max="500" className="form-control" id="fuelCapacity"
                                            placeholder="Enter Fuel Capacity"
                                            onChange={(value) => {
                                                this.setState({ fuelCapacity: value.target.value.trim() }, () => {
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            onKeyDown={(value) => {
                                                this.preventAlphaCharacter(value, value.key);
                                            }}
                                            onPaste={(value) => {
                                                this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData('Text'));
                                            }}
                                            defaultValue={this.props.updateSelection ? this.props.updateSelection?.fuelCapacity : 0}
                                        />}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Tag</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                
                                                this.setState({tag:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={true}
                                            options={this.state.tagOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.tag}
                                        />
                                         :
                                        this.props.updateSelection.tag} 
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Service Provider</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.setState({serviceProvider:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={true}
                                            options={this.state.serviceProviderOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.serviceProvider}
                                        />
                                         :
                                        this.props.updateSelection.serviceProvider} 
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Fuel Type</label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            onChange={(value) => {
                                                this.setState({fuelType:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={false}
                                            options={this.state.fuelOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.fuelType}
                                        />
                                         :
                                        this.props.updateSelection.fuelType} 
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label"><span>
                                      Dispatch Type  </span></label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            onChange={(value) => {
                                                this.setState({dispatchType:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={false}
                                            options={this.state.dispatchTypeOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.dispatchType}
                                        />
                                         :
                                        this.props.updateSelection.serviceProvider} 
                                </div>
                            </div>
                        </div>
                        {this.state.dispatchType && this.state.dispatchType.label === 'Fix' && <><div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label"><span>Route</span></label>
                                <div>
                                    {!this.props.showInfo ?
                                        <Select
                                            closeOnSelect={!this.state.stayOpen}
                                            onChange={(value) => {
                                                this.setState({routeId:value},()=>{
                                                    this.updateFormErrorState();
                                                })
                                            }}
                                            isClearable={false}
                                            options={this.state.routeIdOptions}
                                            placeholder="Select"
                                            rtl={this.state.rtl}
                                            value={this.state.routeId}
                                        />
                                         :
                                        this.props.updateSelection.fuelType} 
                                </div>
                            </div>
                        </div>
                        { this.state.showMultiRouteSelect && <div className="col-sm-6 pe-4 mb-3">
                            <div className="">
                                <label htmlFor="protocolType"
                                    className="form-label">Routes</label>
                                <div>                        
                                    <MultiSelectInput
                                    options={this.state.routeIdOptions}
                                    selectedValues={this.state.routes}
                                    onChange={(value) => {
                                        this.setState({routes:value},()=>{
                                            this.updateFormErrorState();
                                        })
                                    }}
                                    maxSelection={4}
                                    placeholder="Select routes..."
                                    searchPlaceholder="Search routes..."
                                    noOptionsMessage="No routes found"
                                    maxSelectionMessage="Maximum of 4 routes selected"
                                    enableSearch={true}
                                    className="route-selector"
                                    />
                                </div>
                            </div>
                        </div>
                        }
                        </>
                    }
                    <div className="col-sm-12 form-view pt-3">
                        <Button onClick={() => this.props.onClose()} bsPrefix="close-btn">Close</Button>
                        {!this.props.showInfo && <Button bsPrefix="confirm-btn"
                            onClick={() => {
                                this.setState({ loading: true })
                                this.fetchAddUpdate()
                            }}
                            disabled={this.state.form.invalid || this.state.loading}>{this.state.loading ? 'Saving...' : 'Save changes'}</Button>}
                    </div>

                    <Modal show={this.state.showDisabledSeatsModal} onHide={() => this.setState({showDisabledSeatsModal: false})}>
                        <Modal.Header closeButton>
                            <Modal.Title>Select Disabled Seats</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.state.vehicleSeatingLayoutDto?.layout ? (
                                <VehicleSeatingLayout
                                    layoutData={{
                                        layout: this.state.vehicleSeatingLayoutDto.layout,
                                        name: this.state.vehicleSeatingLayoutDto.name
                                    }}
                                    mode="edit"
                                    initialSelectedSeats={this.state.disabledSeats}
                                    onSelectedSeat={(seats) => {
                                        this.setState(
                                            (prevState) => {
                                                const availableSeats = Math.max(
                                                    Number(prevState.vehicleSeatingLayoutDto?.seatingCapacity || 0) - seats.length,
                                                    0
                                                );
                                                return {
                                                    disabledSeats: seats,
                                                    seatingCapacity: availableSeats,
                                                    showDisabledSeatsModal: false
                                                };
                                            },
                                            () => {
                                                this.updateFormErrorState();
                                            }
                                        );
                                    }}
                                />
                            ) : (
                                <div>Please select a layout first.</div>
                            )}
                        </Modal.Body>
                    </Modal>

                </form>
        );

    }

    /**
     * Used to Add/Update Vehicle
     */
    fetchAddUpdate() {
        createOrUpdateVehicle(this.state.selectedRegion.value, this.props.updateSelection, this.state, this.props.email).then((response) => {
            if (this.mounted) {
                this.setState({ loading: false });
                this.props.onComplete(MessageType.SUCCESS, "Successfully done ");
            }
        }).catch((err) => {
            if ((err.status === 401 || err.message === 'Invalid token')) {
                this.props.onComplete(MessageType.ERROR, ("Invalid token"));
            } else if (this.mounted) {
                this.props.onComplete(MessageType.ERROR, (err.description ? err.description : "Error occurred "));
            }
        });

    }


    /**
     * validates vehicle from data
     * @param target
     */
    updateFormErrorState() {
        this.setState(prevState => {
            let {
                routeId,
                routes,
                serviceStartTime,
                serviceEndTime,
                dispatchType,
            } = prevState;

            const label = dispatchType?.label;
            const isManual = label === 'Manual';
            const isAutoOrEtim = ['Auto', 'Etim'].includes(label);

            if (isAutoOrEtim) {
                routeId = null;
                routes = [];
            }

            if (isManual) {
                routeId = null;
                routes = [];
                serviceStartTime = null;
                serviceEndTime = null;
            } else if (!serviceStartTime || !serviceEndTime) {
                const { serviceStartTime: start, serviceEndTime: end } =
                    this.getDefaultServiceWindow();

                serviceStartTime = start;
                serviceEndTime = end;
            }

            const nextState = {
                ...prevState,
                routeId,
                routes,
                serviceStartTime,
                serviceEndTime,
            };

            const formState = validateVehicle(nextState);

            return {
                ...nextState,
                form: formState,
            };
        });
    }



    /**
     *handles the vehicles type change
     * @param value
     */
    handleSelectChange(key, value) {
        if(key == 'selectedRegion'){
            this.fetchTags(value);
        }
        this.setState({ [key]: value }, () => {

            if(key === 'selectedRegion'){
                this.checkAllowedCityForMultiRoute();
            }
            this.updateFormErrorState();
        });

    }

    componentWillUnmount() {
        this.mounted = false;
    }

    fetchProtocolTypeList() {
        fetchProtocolType().then((res => {
            if (this.mounted) {
                this.setState({
                    protocolTypeList: res.content.map(data => ({
                        label: data.name, value: data.name
                    }))
                });
            }

        })).catch(err => {
            if ((err.status === 401 || err.message==='Invalid token')) {
                this.props.setTokenExpired(true);
            } else if (this.mounted) {
                this.setState({ citiesOptions: [] });
                this.props.initiateNotification({
                    type: 'error',
                    message: err.description ? err.description : "Error while fetching master data"
                });
            }
        }
        );
    }

    fetchRoutes ()  {
        let city = this.state.city.label || '';
        let agencyName = this.state.agencyName.label || '';
        if(!city){
            city = this.props.updateSelection.cityMaster.name;
        }
        if(!agencyName){
            agencyName = this.props.updateSelection.agency.name;
        }
        fetchRoutesData(city,agencyName).then(res => {
            res = mappedRoutesData(res);
            let routeId = null;
            let routes = [];
            if(this.props.updateSelection?.vehicleDispatchConfigDto){
                const routeIdObj = res.find((r)=>r.route_id == this.props.updateSelection.vehicleDispatchConfigDto.routeId);
                if(routeIdObj){
                    routeId = {
                        label:generateLabelForRoute(routeIdObj),
                        value:routeIdObj.route_id
                    }
                }
            }
            if (this.props.updateSelection?.vehicleDispatchConfigDto?.routes) {
                const routeObjs = this.props.updateSelection.vehicleDispatchConfigDto.routes;
                const routeIdList = routeObjs.map((obj) => obj.routeId);

                routes = routeIdList;
            }


            let state = {
                routeIdOptions: generateRouteIdOptions(res),
                routes
            };
            if(routeId) state['routeId'] = routeId;
            this.setState(state);
        }).catch(err => this.handleErrorCallback(err,'routeIdOptions'))
    }

    handleErrorCallback = (err,key)=>{
        if ((err.status === 401 || err.message === 'Invalid token')) {
            this.props.setTokenExpired(true);
        } else {
            if(this.state[key]){
                this.setState({ [key]: [] });
            }
            this.props.initiateNotification({type:MessageType.ERROR, message: err.description ? err.description : "Error while fetching routes data"});
        }
    }

    fetchDispatchTypes(){
        fetchDispatchTypesData().then(res => {
                this.setState({
                    dispatchTypeOptions: res.map(data => ({
                        label: data, value: data
                    }))
                });
        }).catch(err => {
            if ((err.status === 401 || err.message === 'Invalid token')) {
                this.props.setTokenExpired(true);
            } else if (this.mounted) {
                this.setState({ dispatchTypeOptions: [] });
                this.props.initiateNotification({type:MessageType.ERROR, message: err.description ? err.description : "Error while fetching dispatch options"});
            }
        }
        );
    }

    fillVehicleDispatchConfigDto = () => {
        if (this.props.updateSelection?.vehicleDispatchConfigDto) {
            const data = this.props.updateSelection.vehicleDispatchConfigDto;
            let serviceStartTime, serviceEndTime;

            try {
                serviceStartTime = generateTimestamp(data.serviceStartTime);
                serviceEndTime = generateTimestamp(data.serviceEndTime);
            } catch (e) {
                console.log(e);
            }

            this.setState({
            dispatchType: { label: data.dispatchType, value: data.dispatchType },
            serviceStartTime,
            serviceEndTime,
            });
        }
    };

    getDefaultServiceWindow = () => {
        const start = moment().startOf('day').add(1, 'minute');
        const end = moment().endOf('day');

        return {
            serviceStartTime: start.format('hh:mm A'),
            serviceEndTime: end.format('hh:mm A'),
        };
    };
}

VehicleCreate.propTypes = {
  updateSelection: PropTypes.object,
  selectedRegion: PropTypes.string,
  onComplete: PropTypes.func,
  showInfo: PropTypes.bool,
  email: PropTypes.string,
  onClose: PropTypes.func,
  initiateNotification: PropTypes.func,
  setTokenExpired : PropTypes.func,
};